/** @format */

import React from 'react';
import { PageContainer } from 'components';
import { CommonProvider } from 'providers';
import { Content } from './components';
import { constBreadCrumbsTitle } from 'utility';

const InvoiceDebtor = () => {


  const hint =
    'در این صفحه فاکتورهایی که توسط کسب‌وکار شما صادر شده و یا کسب‌وکار شما سهمی از آن می‌برد، را مشاهده می‌نمایید. قابلیت فیلتر کردن روی فیلدهای مختلف و دریافت فایل خروجی نیز وجود دارد.';

  return (
    <PageContainer
      title=" فاکتورهای فروش"
      description={hint}
      pageKey="invoiceDebtor"
      breadcrumbs={constBreadCrumbsTitle.INVOICE_LIST}
    >
      <CommonProvider>
        <Content />
      </CommonProvider>
    </PageContainer>
  );
};

export default InvoiceDebtor;
